<template>
  <div class="howPeopleUseContainer has-text-centered">
    <h2 class="h1 mb-4">
      {{ $t('page.whatIsLiffery.new2023.OMeetJenBen.title') }}
    </h2>

    <div class="face-container" id="face-container">
      <div class="is-inline-block face-woman"
           :class="{'selected-face': womanSelected}"
           @click="selectWoman"
      >
        <div class="highlight-circle"/>
        <img class="face"
             src="@/assets/landing-pages/forPeople/2023/face-woman-glasses.svg"
             alt="Liffery fan"/>
      </div>

      <div class="is-inline-block face-man"
           :class="{'selected-face': manSelected}"
           @click="selectMan"
      >
        <div class="highlight-circle"/>
        <img class="face"
             src="@/assets/landing-pages/forPeople/2023/face-man-beard.svg"
             alt="Liffery fan"/>
      </div>
    </div>

    <div class="tab-container">
      <div class="tab-control"
           :class="{active: womanSelected}"
           @click="selectWoman"
      >
        {{ $t('page.whatIsLiffery.new2023.OMeetJenBen.meetJ9') }}
      </div>
      <div class="tab-control"
           :class="{active: manSelected}"
           @click="selectMan"
      >
        {{ $t('page.whatIsLiffery.new2023.OMeetJenBen.meetJohn') }}
      </div>
    </div>

    <div class="text-container pl-2 pr-2">
      <div class="text-block text-woman"
           :class="{active: womanSelected}"
           @click="selectWoman"
      >
        <p class="has-text-right">
          {{ $t('page.whatIsLiffery.new2023.OMeetJenBen.j9Text') }}
        </p>
      </div>

      <div class="text-block text-man"
           :class="{active: manSelected}"
           @click="selectMan"
      >
        <p>
          {{ $t('page.whatIsLiffery.new2023.OMeetJenBen.johnText') }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.howPeopleUseContainer {
  padding: 2rem 0 8rem 0;
  margin-top: 3rem;
  position: relative;

  @media screen and (max-width: $tablet) {
    padding-bottom: 4rem;
  }
}

.face-container,
.tab-container,
.text-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;

  margin-bottom: 2rem;
}

.face-container {
  margin-top: 6.8rem;

  img.face {
    position: relative;
    z-index: 10;
    opacity: .3;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  .highlight-circle {
    position: absolute;
    height: 179px;
    width: 179px;
    border-radius: 179px;
    background-color: #d3f6f9;
    opacity: 0;
  }

  .face-woman, .face-man {
    position: relative;

    &:hover:not(.selected-face) {
      .highlight-circle {
        opacity: .2;
      }
    }
  }

  .face-woman .highlight-circle {
    left: -50px;
    top: -28px;
  }

  .face-man .highlight-circle {
    left: -15px;
    top: -28px;
  }

  .selected-face {
    img.face {
      opacity: 1;
      cursor: default;
    }

    .highlight-circle {
      opacity: 1;
    }
  }
}

.tab-container {
  .tab-control {
    border-bottom: 1px solid transparent;
    cursor: pointer;

    &:hover,
    &.active {
      border-bottom: 1.5px dashed var(--black-color);
    }

    &.active {
      font-weight: $fontWeightBold;
    }
  }
}

.text-container {
  .text-block {
    opacity: .2;
    cursor: pointer;
    width: 500px;
    max-width: 500px;

    &.active {
      opacity: 1;
    }

    &:hover:not(.active) {
      opacity: .4;
    }
  }

  .text-woman {
    text-align: right;
  }

  .text-man {
    text-align: left;
  }
}
</style>


<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import OArrowDownScroll from '@/components/organisms/landing/sections/OArrowDownScroll.vue';

@Component({
  components: { OArrowDownScroll }
})
export default class OMeetJenBen extends Vue {
  @Prop({ default: 'woman' })
  selected!: 'woman' | 'man';

  @Watch('selected')
  selectedHandle () {
    this.womanSelected = this.selected === 'woman';
    this.manSelected = this.selected === 'man';
  }

  womanSelected = true;
  manSelected = false;

  selectMan () {
    this.womanSelected = false;
    this.manSelected = true;
    this.emit();
  }

  selectWoman () {
    this.womanSelected = true;
    this.manSelected = false;
    this.emit();
  }

  emit () {
    this.$emit('select-face', {
      womanSelected: this.womanSelected,
      manSelected: this.manSelected
    });
  }
}
</script>
